import { trackHeapEvent } from '../../trackHeapEvent'

export enum BusinessDetailsHeapEvents {
  saveSingle = 'location-details-save-single-business-details',
  saveMultiple = 'location-details-save-multiple-business-details',
}
interface ActionsBusinessCommonProps {
  field: string
}

export interface SaveSingleBusinessDataProps extends ActionsBusinessCommonProps {
  status: 'Success' | 'Fail'
  storeLocationId: string
}

export interface SaveMultipleBusinessDataProps extends ActionsBusinessCommonProps {
  status: 'Success' | 'Fail'
  storeLocationsCount: string
  foldersCount: string
}

export interface CancelSingleBusinessDataProps extends ActionsBusinessCommonProps {
  storeLocationId: string
}

export interface CancelMultipleBusinessDataProps extends ActionsBusinessCommonProps {
  storeLocationsCount: string
  foldersCount: string
}

export const businessDetailsTrackingEvents = {
  saveForSingleLocation(data: SaveSingleBusinessDataProps) {
    trackHeapEvent(BusinessDetailsHeapEvents.saveSingle, data)
  },

  saveForMultipleLocations(data: SaveMultipleBusinessDataProps) {
    trackHeapEvent(BusinessDetailsHeapEvents.saveMultiple, data)
  },

  cancelForSingleLocation(data: CancelSingleBusinessDataProps) {
    trackHeapEvent(
      BusinessDetailsHeapEvents.saveSingle,
      Object.assign(
        {
          status: 'Canceled',
        },
        data,
      ),
    )
  },

  cancelForMultipleLocations(data: CancelMultipleBusinessDataProps) {
    trackHeapEvent(
      BusinessDetailsHeapEvents.saveMultiple,
      Object.assign(
        {
          status: 'Canceled',
        },
        data,
      ),
    )
  },
}
